export function initPagination() {
  const paginationButtons = document.querySelectorAll(".page-numbers");
  const prevButton = document.querySelector(".blog__bottom-box .prev");
  const nextButton = document.querySelector(".blog__bottom-box .next");

  if (!(paginationButtons.length && prevButton)) return;

  if (!nextButton) {
    prevButton.style.right = "0";
  }
}
